import { X_URL } from "../config";
import Mascot from "./Mascot";
import Reveal, { SectionHead } from "./Reveal";

const CARDS = [
    { name: "galleryOg", title: "THE OG BALD" },
    { name: "galleryTrader", title: "THE TRADER" },
    { name: "galleryKing", title: "THE KING" },
    { name: "galleryDegen", title: "THE DEGEN" },
    { name: "galleryMillion", title: "THE MILLION CLUB" },
    { name: "galleryStreet", title: "THE STREET PIGEON" },
    { name: "gallerySolana", title: "THE SOLANA PIGEON" },
];

export default function Gallery() {
    return (
        <section data-testid="gallery-section" className="relative py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <SectionHead kicker="THE ARCHIVE" title="THE BALD PIGEON ARCHIVE" />
                <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
                    {CARDS.map((c, i) => (
                        <Reveal key={c.name} delay={(i % 4) * 0.08} className="h-full">
                            <div
                                data-testid={`gallery-card-${i + 1}`}
                                className="group relative aspect-square h-full overflow-hidden rounded-2xl border border-white/10 transition-all duration-500 hover:border-cyan-400/50 hover:shadow-[0_0_36px_rgba(0,240,255,0.22)]"
                            >
                                <Mascot
                                    name={c.name}
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
                                <div className="absolute inset-x-0 bottom-0 p-4">
                                    <h3 className="headline text-base text-white transition-all duration-500 md:text-lg lg:translate-y-3 lg:opacity-0 lg:group-hover:translate-y-0 lg:group-hover:opacity-100">
                                        {c.title}
                                    </h3>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                    <Reveal delay={0.24} className="h-full">
                        <a
                            href={X_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="gallery-card-more"
                            className="glass glass-hover flex aspect-square h-full w-full flex-col items-center justify-center gap-3 rounded-2xl text-center"
                        >
                            <span className="headline text-2xl text-gradient">YOUR MEME HERE</span>
                            <span className="font-mono text-xs uppercase tracking-widest text-slate-500">
                                Make the internet bald →
                            </span>
                        </a>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
